var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5489 0.927049C10.8483 0.0057386 12.1517 0.00574004 12.4511 0.927051L14.4187 6.98278C14.5526 7.3948 14.9365 7.67376 15.3697 7.67376H21.7371C22.7058 7.67376 23.1086 8.91338 22.3249 9.48278L17.1736 13.2254C16.8231 13.4801 16.6764 13.9314 16.8103 14.3435L18.7779 20.3992C19.0773 21.3205 18.0228 22.0866 17.2391 21.5172L12.0878 17.7746C11.7373 17.5199 11.2627 17.5199 10.9122 17.7746L5.7609 21.5172C4.97719 22.0866 3.92271 21.3205 4.22206 20.3992L6.18969 14.3435C6.32356 13.9314 6.1769 13.4801 5.82642 13.2254L0.675105 9.48278C-0.108608 8.91338 0.294168 7.67376 1.26289 7.67376H7.63026C8.06349 7.67376 8.44744 7.3948 8.58132 6.98278L10.5489 0.927049Z",
    fill: "#64739A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.9bc2ae56731bc8b04033450a18d46ffa.svg";
export { ForwardRef as ReactComponent };